import Filter from './filter';
import {throttle} from "../utils";

class ShopFilter extends Filter {
    constructor({ $node }) {
        super({
            $node: $node
        });

        this.$shopsItems = this.$wrapper.find('.js-filter-shops-items');
        this.$servicesItems = this.$wrapper.find('.js-filter-services-items');
        this.$servicesSection = this.$servicesItems.closest('.section');
        this.$actionsItems = this.$wrapper.find('.js-filter-actions-items');
    }

    _formBehavior() {
        const $form = this.$filterForm;

        $form.on('change', throttle(() => {
            $form.trigger('submit');
        }));

        $form.submit(() => {
            this._formSubmitHandler().then(({ shops, services, actions }) => {

                if (shops) {
                    this.$shopsItems.html(shops);
                    if (!this.$shopsItems.is(':visible')) this.$shopsItems.show(0);

                } else {
                    this.$shopsItems.hide();
                }

                if (services) {
                    this.$servicesItems.html(services);
                    if (!this.$servicesSection.is(':visible')) this.$servicesSection.show(0);

                } else {
                    this.$servicesSection.hide();
                }

                if (actions) {
                    this.$actionsItems.html(actions);
                    if (!this.$actionsItems.is(':visible')) this.$actionsItems.show(0);

                } else {
                    this.$actionsItems.hide();
                }
            });

            return false;
        });
    }
}

export default ShopFilter;



// WEBPACK FOOTER //
// ./components/shopFilter.js